/**
 * Attribution capture for the HuddleUp SPA.
 *
 * On the very first pageview of a browser session we snapshot the
 * marketing signals we care about (UTM parameters, HTTP referrer, and
 * the landing path) and keep them in sessionStorage so that later
 * diagnostic / partner submissions can attach them to the lead — even
 * if the user has clicked around the site by then.
 *
 * We only capture *once* per session, so subsequent internal navigation
 * never overwrites the true entry point.
 */

const KEY = "huddleup:attribution:v1";
const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
];

function readSaved() {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function captureAttributionOnce() {
  if (typeof window === "undefined") return;
  if (readSaved()) return;

  const params = new URLSearchParams(window.location.search);
  const snapshot = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) snapshot[k] = v;
  });

  const referrer = document.referrer || "";
  if (referrer) snapshot.referrer = referrer;

  snapshot.landing_path = window.location.pathname + window.location.search;

  try {
    sessionStorage.setItem(KEY, JSON.stringify(snapshot));
  } catch {
    /* sessionStorage disabled — attribution is best-effort */
  }
}

export function getAttribution() {
  return readSaved() || {};
}
